export default class BrixModuleTabMenu {
  static init(...parameters) {
    return new BrixModuleTabMenu(...parameters);
  }

  constructor(selector) {
    this.selector = selector;

    if (!this.selector.classList.contains('-no-reload')) {
      return;
    }

    this.menu = selector.querySelectorAll('.menu-item');
    this.tabs = selector.querySelectorAll('.tab');

    // Set ARIA attributes for tabs on initialization
    [...this.tabs].forEach((tab) => {
      const { hash } = tab.dataset;
      tab.setAttribute('id', `tabpanel-${hash}`);
      tab.setAttribute('aria-labelledby', `tab-${hash}`);
    });

    [...this.menu].forEach((item) => {
      item.addEventListener('click', event => this.handleMenuClick(event));

      if (window.location.hash === `#${item.dataset.hash}`) {
        const scrollToElement = selector.querySelector(`.${selector.id}-anchor-${item.dataset.hash}`);
        if (scrollToElement) {
          setTimeout(() => {
            scrollToElement.scrollIntoView();
          }, 200);
        }

        this.setCurrent(item.dataset);
      }
    });

    window.addEventListener('hashchange', () => {
      [...this.menu].forEach((item) => {
        if (window.location.hash === `#${item.dataset.hash}`) {
          this.setCurrent(item.dataset);
        }
      });
    });
  }

  handleMenuClick(event) {
    this.setCurrent(event.target.dataset);
  }

  setCurrent(dataset) {
    if (window.location.hash !== dataset.hash) {
      window.location.hash = dataset.hash;
    } else {
      window.location.hash = '';
    }

    [...this.menu].forEach((item) => {
      if (item.dataset.id === dataset.id) {
        item.classList.add('-current');
        item.setAttribute('aria-selected', 'true');
      } else {
        item.classList.remove('-current');
        item.setAttribute('aria-selected', 'false');
      }
    });
    [...this.tabs].forEach((tab) => {
      if (tab.dataset.id === dataset.id) {
        tab.classList.add('-current');
      } else {
        tab.classList.remove('-current');
      }
    });
  }
}

// Register class
window.brix && window.brix.registerBlock && window.brix.registerBlock('brix-tab-menu', BrixModuleTabMenu.init);
